/* Nani — DeAnna's Size Tip: tap-to-open for touch, Esc / outside click to close. */
(() => {
  const close = (el) => { el.classList.remove('is-open'); el.querySelector('[data-dst-q]')?.setAttribute('aria-expanded', 'false'); };
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-dst-q]');
    document.querySelectorAll('[data-dst].is-open').forEach(el => { if (!q || !el.contains(q)) close(el); });
    if (!q) return;
    const root = q.closest('[data-dst]');
    const open = root.classList.toggle('is-open');
    q.setAttribute('aria-expanded', String(open));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') document.querySelectorAll('[data-dst].is-open').forEach(close); });
})();
